import React  from 'react';
import { Link } from 'react-router-dom';
import {
  AreaTitle,
  BottomMessage,
  ContainerBody,
  DebtMessageTime,
  BottomMessageAccess,
  ButtonDivision,
  ButtonOutline,
} from "./styles";
import warning from '~/assets/images/warning-red.svg';
import information from '~/assets/images/information-blue.svg'
import { formatDateTimeWithOffset } from '~/utils/utils';
import { InfoButton } from '~/components/layout/Buttons';
import { useHistory } from 'react-router-dom';

export default function Debt({ dateAvailable }) {
  
  const history = useHistory();

  return(
    <ContainerBody>
      <AreaTitle>
        <img src={warning} alt="Debito no pedido" />
      </AreaTitle>
      <BottomMessage>
        Para prosseguir com o processamento do seu pedido, é necessário  quitar os valores em aberto.
      </BottomMessage>

      <ButtonDivision onClick={() => history.push('/pagar-debito-anterior')}>
        <InfoButton style={{ margin: "0.5rem 0 0.5rem 0" }}>
          <div>Consultar valores em aberto</div>
        </InfoButton>
      </ButtonDivision>

      {dateAvailable &&
        <>
        <DebtMessageTime>
          <img src={information} alt="info no pedido" /> {`Pedido disponível até ${dateAvailable ? formatDateTimeWithOffset(dateAvailable) : dateAvailable}, horário de Brasília.`}
        </DebtMessageTime>
        <BottomMessageAccess>
          Caso o pagamento não seja identificado até esse horário, o pedido será cancelado
        </BottomMessageAccess>
        </>
      }

      <ButtonDivision onClick={() => history.replace('/portal')}>
        <ButtonOutline outline style={{ marginBottom: '1rem' }}>
          <div>Cancelar pedido</div>
        </ButtonOutline>
      </ButtonDivision>

      <BottomMessageAccess>
        Não se esqueça de apresentar a Nota Fiscal na retirada do seu pedido!
        Confira <Link to="/confirmacao-pedido">aqui</Link> para mais orientações para facilitar o processo.
      </BottomMessageAccess>
    </ContainerBody>
  );
}
